/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { history } from '../../Helpers/history';
import config from '../../Helpers/config.json';
import * as snackbarActions from '../../Redux/Actions/SnackbarActions/SnackbarActions';
import ReusableDashboardHeader from '../../Containers/Dasboard/ReusableDashboardHeader';
import PharmacySnackbar from '../../Utils/Snackbars/SnackbarUtil';
import InvoiceContent from './InvoiceContent';
import { useCustomA4Print } from '../../Utils/Template/useCustomA4Print';
import { errorMessages } from '../../Helpers/ErrorMessages';
import { BackButton } from "../../Utils/Buttons/DataExportationButton";

const BigInvoiceScreen = ({ actions, snackbars, match: { params } }) => {
  const [data, setData] = useState({ products: [], customer: {} });
  const [loading, setLoading] = useState('idle');
  const { invoice_id, customer_id ,is_dispensar,is_cashier} = params;
  const disp = is_dispensar === 'true';
  const cash = is_cashier === 'true';
  
  // Use our custom A4 print hook
  const { handlePrint, componentRef } = useCustomA4Print(`Invoice ${invoice_id}`);

  // console.log(is_dispensar, is_cashier); // "false", "true"

  // console.log(disp, cash); // "false", "true"



  // alert(is_cashier)


  useEffect(() => {
    setLoading('pending');
    const formData = new FormData();
    formData.append('receipt_number', '');
    formData.append('invoice_number', invoice_id);
    formData.append('customer_id', customer_id);

    axios.post(`${config.epharmUrl}/Cinvoice/view_receipt`, formData)
      .then(response => {
        const dt = response.data || {};
        const arr = dt.bill || [];
        const customer_details = dt.customer_details || {};
        setData({ products: arr, customer: { ...customer_details, ...(arr[0] || {}) } });
        setLoading('resolved');
      })
      .catch(error => {
        errorMessages(error, null, actions);
        setLoading('rejected');
      });
  }, [invoice_id, customer_id]);

  const { variant, message, open } = snackbars;
  const { products, customer } = data;

  return (
    <div>
      <ReusableDashboardHeader
        component="Big Invoice"
        heading="Customer Invoice"
        subHeading="Full A4 Invoice"
        link={history.location.pathname}
      />

      <PharmacySnackbar
        open={open}
        variant={variant}
        message={message}
        handleCloseBar={() => actions.snackbarActions.hideSnackBar()}
      />

      <div className="d-flex justify-content-between mb-3 mr-5">
        <button onClick={handlePrint} className="btn btn-primary">Print Invoice</button>
        <div>
          {cash ? (
            <BackButton to="/managependingsale" text="Approve Sales" />
          ) : !disp ? (
            <BackButton to="/manageinvoice" text="Invoices Sales" />
          ) : (
            <BackButton to="/pendingapproval" text="Approved Sales" />
          )}
        </div>

      
      
      </div>

      {loading === 'pending' && (
        <div className="text-center mt-5">
          <img src="/images/listPreloader.gif" alt="loader" style={{ width: '10%' }} />
        </div>
      )}

      {loading === 'resolved' && (
        <div
          ref={componentRef}
          id="customA4Print"
        >
          <InvoiceContent  customer={customer} products={products} />
        </div>


      )}

      {loading === 'rejected' && (
        <div className="text-center mt-5">Failed to load invoice</div>
      )}
    </div>
  );
};

const mapStateToProps = state => ({ snackbars: state.snackbars });
const mapDispatchToProps = dispatch => ({ actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) } });

export default connect(mapStateToProps, mapDispatchToProps)(BigInvoiceScreen);
